import { useState } from 'react';
import { theme } from '../../theme';
import ConversationCard from './ConversationCard';

export default function ConversationList({ conversations, activeId, onSelect, onViewHistory, isMobile }) {
  const [search, setSearch] = useState('');
  const filtered = conversations.filter(
    (c) => c.owner.includes(search) || (c.contact_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ width: isMobile ? '100%' : '280px', display: 'flex', flexDirection: 'column', borderRight: `1px solid ${theme.colors.border}`, overflowY: 'auto' }}>
      <div style={{ padding: '10px 12px', borderBottom: `1px solid ${theme.colors.border}` }}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="🔍 Buscar..."
          style={{
            width: '100%', padding: '7px 10px', borderRadius: '8px',
            background: theme.colors.background, border: `1px solid ${theme.colors.border}`,
            color: theme.colors.text, outline: 'none', fontSize: '0.85rem', boxSizing: 'border-box',
          }}
        />
      </div>
      {filtered.length === 0 && (
        <div style={{ padding: '2rem', textAlign: 'center', color: theme.colors.textMuted, fontSize: '0.85rem' }}>
          Sin conversaciones activas
        </div>
      )}
      {filtered.map((conv) => (
        <ConversationCard
          key={conv.id}
          conv={conv}
          isActive={conv.id === activeId}
          onSelect={onSelect}
          onViewHistory={onViewHistory}
        />
      ))}
    </div>
  );
}
